import { defHttp } from '@/utils/http/axios'

/***
 * @description 手机号获得燃气户信息
 */
export function queryGasUserList(params: object) {
  return defHttp.get({ url: `/trade/order/place/crm/member/info`, params })
}

/***
 * @description 根据部门id获取用户列表
 */
export function queryDeftList(params: { deptIds: number[] }) {
  return defHttp.post({ url: `/system/user/dept/list?deptIds=${params.deptIds}`, params })
}

/***
 * @description 获取气站列表
 */
export function queryStationList(params) {
  return defHttp.get({ url: `/trade/order/place/station/info`, params })
}
/***
 * @description 获得自提门店列表
 */
export function queryPickStoreList(params) {
  return defHttp.get({ url: `/trade/delivery/pick-up-store/list-all-simple`, params })
}

/**
 * @description 归属门店
 *
 */
export function queryNearStore(params?) {
  return defHttp.get({ url: `/trade/delivery/pick-up-store/near/list-all-simple`, params })
}

/***
 * @description 客户价格所属机构
 */
export function getStoreDepList(ids) {
  return defHttp.get({ url: `/trade/delivery/pick-up-store/list?ids=${ids}` })
}

/***
 * @description 更新联系人
 */
export function updateUserContacts(params) {
  return defHttp.put({ url: `/crm/member/user/update/phone`, params }, { isTransformResponse: false })
}

/***
 * @description 更新燃气户信息
 */
export function updateGasInfo(params) {
  return defHttp.put({ url: `/crm/member/user/update`, params })
}

/***
 * @description 查询用户的购物车列表
 */
export function queryUserCartList(params) {
  return defHttp.get({ url: `/bash/trade/cart/list`, params })
}

/***
 * @description 批量添加购物车商品
 */
export function addCartCommodityBatch(params) {
  return defHttp.post({ url: `/bash/trade/cart/add/batch`, params })
}

/***
 * @description 重置购物车商品
 */
export function updateCartCommodityBatch(params) {
  return defHttp.post({ url: `/bash/trade/cart/update/batch`, params })
}

/***
 * @description 删除购物车商品
 */
export function deleteCartCommodity(params) {
  return defHttp.delete({ url: `/bash/trade/cart/delete?ids=${params.ids}&&userId=${params.userId}`, params })
}
/***
 * @description 创建订单
 */
export function createOrder(params, terminal) {
  return defHttp.post({ url: `/trade/order/place/create`, params, headers: { terminal } })
}

/***
 * @description 根据岗位获取用户列表
 */
export function selectUserByPostCode(params) {
  return defHttp.get({ url: `/system/user/selectUserByPostCode`, params })
}

// 获取历史订单
export function crmHisList(params) {
  return defHttp.get({ url: `/trade/order/place/crm/his/list`, params })
}

// 获取历史订单
export function selectMemberByParam(params) {
  return defHttp.get({ url: `/member/user/selectMemberByParam`, params })
}

// 更改门店
export function changeStore(params) {
  return defHttp.put({ url: `/crm/member/user/update/changeStore`, params })
}

/***
 * @description 根据门店id获取转单用户列表
 */
export function queryStorePeopleList(params: { storeId: number[], name: string }) {
  return defHttp.post({ url: `/system/user/getUserList?storeId=${params.storeId}&name=${params.name}`, params })
}

/***
 * @description 更新燃气户地址
 */
export function updateAddress(params) {
  return defHttp.put({ url: `/crm/member/user/updateAddress`, params })
}
/***
 * @description 获取派单门店下拉列表(无数据过滤)
 */
export function pickUpStoreSelect(params) {
  return defHttp.get({ url: `/trade/delivery/pick-up-store/pickUpStoreSelect`, params })
}


/***
 * @description 创建回收业务单
 */
export function createRecovery(params) {
  return defHttp.post({ url: `/trade/recovery-order/create`, params })
}